import React, { memo } from 'react';

const RewardPromo = () => {
  return <></>;
};

export default memo(RewardPromo);
